/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Tracking_Refreshing_BtnInputs */

const tr_geliver_tracking_refreshing_btn = /** @type {(inputs: Geliver_Tracking_Refreshing_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yenileniyor...`)
};

const en_geliver_tracking_refreshing_btn = /** @type {(inputs: Geliver_Tracking_Refreshing_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refreshing...`)
};

const de_geliver_tracking_refreshing_btn = /** @type {(inputs: Geliver_Tracking_Refreshing_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisiert...`)
};

const ru_geliver_tracking_refreshing_btn = /** @type {(inputs: Geliver_Tracking_Refreshing_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновление...`)
};

/**
* | output |
* | --- |
* | "Refreshing..." |
*
* @param {Geliver_Tracking_Refreshing_BtnInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_tracking_refreshing_btn = /** @type {((inputs?: Geliver_Tracking_Refreshing_BtnInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Tracking_Refreshing_BtnInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_tracking_refreshing_btn(inputs)
	if (locale === "de") return de_geliver_tracking_refreshing_btn(inputs)
	if (locale === "ru") return ru_geliver_tracking_refreshing_btn(inputs)
	return tr_geliver_tracking_refreshing_btn(inputs)
});